import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { IUser } from "../../context/AuthProvider/types";

import { Api } from "../../services/api";
import { AxiosRequestConfig, AxiosError } from "axios";
import loginBackground from '../../assets/images/keyDrive-background.png'
import { BackgroundImage } from "./components/BackgroundImage/BackgroundImage";
import { KeyLogos } from "./KeyLogos";

const ILayoutPublic: React.FunctionComponent<IUser> = (props) => {
  Api.interceptors.response.use(
    function (config: AxiosRequestConfig) {
      return config;
    },
    function (error: AxiosError) {
      return Promise.reject(error);
    }
  );

  const location = useLocation();

  return (
    <>
      <BackgroundImage
        component={'img'}
        backgroundImage={loginBackground}
      >
        <Outlet />
      </BackgroundImage>

      { !location.pathname.includes("/plan") && !location.pathname.includes("/wizard") && <KeyLogos/> }
    </>
    
  );
};

export default ILayoutPublic;
